<template>
    <div class="user-review-item col-12 col-sm-4 col-lg-3"
        @mouseenter="editing = (editable && true)"
        @mouseleave="editing = false">
        <div class="handle"></div>
        <div class="user-review-avatar">
            <content-unit
                :onContentUnitChange=onContentUnitChange
                :outerWrapperClass="''"
                :key="userReview.contentUnit.id"
                :context="context"
                :enableCrop="true"
                :providerId="context.providerId"
                :providerInformationBlockId="providerInformationBlockId"
                :contentUnit="userReview.contentUnit">

                <div slot="template" slot-scope="props">
                    <img v-if="userReview.contentUnit.file_name || props.imageData"
                        :src="props.imageData ? props.imageData : context.storageEndpoint + userReview.contentUnit.file_name"
                        @click="props.promptImageSelector" />
                    <button class="avatar-placeholder" @click="props.promptImageSelector" v-else-if="editable">
                        <i class="fa fa-image" aria-hidden="true"></i>
                    </button>
                </div>
            </content-unit>
        </div>
        <div class="user-review-name">
            <editable-text
                v-if="editable"
                :editInputClass="'form-control'"
                :outerWrapperClass="''"
                :doneButtonClass="'btn btn-primary btn-sm btn-block mt-2'"
                :text="userReview.name"
                :onDone="onNameChange" />
        </div>
        <p class="user-review-content">
            <editable-text
                v-if="editable"
                :editInputClass="'form-control'"
                :outerWrapperClass="''"
                :doneButtonClass="'btn btn-sm btn-primary btn-block mt-2'"
                :use-textarea="true"
                :text="userReview.content"
                :onDone="onContentChange" />
            <!-- <span style="white-space: pre-line;" v-else>{{userReview.content}}</span> -->
        </p>
        <button
            v-if="editing"
            class="user-review-delete-button btn btn-danger"
            @click="onDelete(userReview)"><i class="fa fa-minus" aria-hidden="true"></i></button>
    </div>
</template>

<script>
export default {
    props: {
        userReview: Object,
        context: Object,
        onChange: Function,
        onDelete: Function,
        providerInformationBlockId: Number,
        editable: {
            type: Boolean,
            default: true
        }
    },

    data: function() {
        return {
            editing: false
        }
    },

    methods: {
        onNameChange(newName) {
            this.onChange(Object.assign({}, this.userReview, {
                name: newName
            }));
        },
        onContentChange(newContent) {
            this.onChange(Object.assign({}, this.userReview, {
                content: newContent
            }));
        },
        onContentUnitChange(newContentUnit) {
            this.onChange(Object.assign({}, this.userReview, {
                contentUnit: newContentUnit
            }));
        }
    }
}
</script>

<style scoped lang="scss">
    .user-review-item {
        position: relative;
        text-align: center;
        margin-top: 1em;
    }

    .user-review-item:hover .handle {
        display: block;
    }

    .handle {
        display: none;
        top: -5px;
        left: 20px;
    }

    .user-review-avatar img, .avatar-placeholder {
        width: 76px;
        height: 76px;
        border-radius: 38px;
        cursor: pointer;
    }

    .avatar-placeholder {
        background: #cccccc;
        color: white;
        font-size: 20px;
    }

    .user-review-name {
        font-weight: bold;
        margin: 0.8em auto;
        font-size: 1.2em;
    }

    .user-review-content {
        font-style: italic;
        font-size: 0.9em;
    }

    .user-review-delete-button {
        padding: 0;
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        line-height: 20px;
        color: white;
        position: absolute;
        border-color: transparent;
        top: 0px;
        right: 36px;

        i {
            position: relative;
            top: -2px;
        }
    }
</style>
